import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {FileUploader, FileItem, ParsedResponseHeaders} from 'ng2-file-upload';

import {UploadUrl} from '../../lib/config';

import { ExtendFileItem } from '../../lib/interface';

@Component({
  selector: 'app-upload-simple',
  templateUrl: './upload-simple.component.html',
  styleUrls: ['./upload-simple.component.css']
})
export class UploadSimpleComponent implements OnInit {
  @Output() uploadSuccessCallback: EventEmitter<FileUploader> = new EventEmitter<FileUploader>();
  private uploader: FileUploader = new FileUploader({
    url: UploadUrl,
    isHTML5: true,
    autoUpload: true,
  });
  constructor() {
    this.uploader.onSuccessItem = this.uploadSuccess.bind(this);
  }
  ngOnInit() {
  }
  uploadSuccess(item: ExtendFileItem, response, status: number, headers: ParsedResponseHeaders) {
    response = JSON.parse(response);
    const result = response.body.result;
    result.name = item.file.name;
    result.type = /image/.test(item.file.type) ? 1 : 2;
    this.uploadSuccessCallback.emit(result);
  }

}



// WEBPACK FOOTER //
// /Users/liyankai/Documents/github/seiya_web.git/src/app/shared/upload-simple/upload-simple.component.ts